import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'LicensedData' })({
    blur: {
        display: 'inline-block',
        position: 'relative',
        fontSize: 'inherit',
        fontWeight: 'inherit',
        lineHeight: 'inherit',
        fontFamily: 'monospace',
        color: 'inherit',
        userSelect: 'none',
        cursor: 'pointer',
        wordBreak: 'break-all',
        ['&:before']: {
            zIndex: 1,
            content: '""',
            borderRadius: 4,
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            background: '#fff',
            transition: 'opacity 0.25s',
            opacity: 0
        },
        ['&:after']: {
            zIndex: 2,
            content: '""',
            borderRadius: 4,
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backdropFilter: 'blur(8px)',
            background: 'transparent'
        },
        ['&:hover:before']: {
            opacity: 0.2
        }
    },
    rounded: {
        ['&:before']: {
            borderRadius: '50%'
        },
        ['&:after']: {
            borderRadius: '50%'
        }
    }
});
